module.exports = __webpack_public_path__ + "static/img/bacground.6c42c8aa.png";